<template>
  <NuxtLayout name="default">
    <div
      class="mx-auto flex w-full max-w-[1440px] flex-col items-center gap-10 px-6 pb-spacing_17 pt-5 md:gap-[60px] md:px-[150px] md:pt-0"
    >
      <slot></slot>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts"></script>

<style>
.cart-template {
  .cart-main-container {
    @apply gap-[50px];
  }

  .cart-list {
    @apply md:w-[659px];
  }
}
</style>
